import Dashboard from '@/pages/Dashboard';
import Login from '@/pages/Login';
import ForgotPassword from '@/pages/ForgotPassword';
import ChangePassword from '@/pages/ChangePassword';

export default [
  {
    path: '/',
    alias: '/home',
    name: 'home',
    component: Dashboard, // TODO: admin dashboard if admin/root
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_view_own_timesheet'],
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: {
      title: '',
    },
  },
  {
    path: '/forgot-password/change/:key',
    name: 'change-password',
    component: ChangePassword,
    meta: {
      title: '',
    },
  },
];
